import React, { useReducer, useState, useEffect } from 'react';
import style from './Register.module.css';
import axios from '../../functions/axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import MultipleSelectCheckmarks from '../componets/MultipleSelectCheckmarks';

function EditUserByAdmin() {
  const { user } = useAuthContext();
  const location = useLocation();
  const [cars, setCars] = useState([]);
  const formReducer = (state, event) => {
    const form = {
      ...state,
      [event.name]: event.value,
    };
    if (!event.value) {
      delete form[event.name];
    }
    return form;
  };

  const [formData, setFormData] = useReducer(formReducer, {
    _id: location.state._id,
    userName: location.state.userName,
    surName: location.state.surName,
    email: location.state.email,
    manageUsers: location.state.permissions.manageUsers || false,
    manageCarriage: location.state.permissions.manageCarriage || false,
    manageInvoice: location.state.permissions.manageInvoice || false,
    managePaletts: location.state.permissions.managePaletts || false,
    manageCarsService: location.state.permissions.manageCarsService || false,
    manageNotes: location.state.permissions.manageNotes || false,
    allowedCars: (location.state.allowedCars || []).map((car) => (typeof car === 'string' ? car : car._id)),
  });
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const validateData = () => {
    if (formData.password) {
      if (formData.password.length < 8 || formData.password !== formData.passwordConfirm) return false;
    }

    return formData.userName && formData.surName && formData.email;
  };

  const handleSubmit = async (event) => {
    if (event.target.id !== 'submit') return;
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);
    if (!validateData()) return;
    await axios.patch(`/userAdmin`, formData);
    setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    navigate('/userList');
  };

  const handleDeleteAppUser = async (event) => {
    if (event.target.id !== 'remove') return;
    event.preventDefault();
    event.stopPropagation();
    const confirmBox = window.confirm('Czy chcesz usunąć tego użytkownika?');
    if (confirmBox) {
      await axios.delete(`/user`, {
        data: {
          _id: location.state._id,
        },
      });
    }
    navigate('/userList');
  };

  const handleForceLogout = async (event) => {
    if (event.target.id !== 'force-logout') return;
    event.preventDefault();
    event.stopPropagation();
    const confirmBox = window.confirm('Czy chcesz wymusić wylogowanie tego użytkownika ze wszystkich urządzeń?');
    if (confirmBox) {
      await axios.post(`/forceLogout`, {
        _id: location.state._id,
      });
    }
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  const ConfirmData = () =>
    validateData() ? (
      <div>
        <label>OK! Dane zostały wprowadzone</label>:
        <ul>
          <li>Nazwa użytkownika: {formData.userName}</li>
          <li>Imię i Nazwisko: {formData.surName}</li>
        </ul>
      </div>
    ) : (
      <div>
        <label>Niepoprawne dane, hasło musi mieć co najmniej 8 znaków i być zgodne z potwierdzeniem hasła.</label>
      </div>
    );

  useEffect(() => {
    if (!user) return null;
    (async () => {
      try {
        const { data: response } = await axios.get(`/car`);
        setCars(response);
      } catch (error) {
        console.error(error.message);
      }
    })();
  }, [user]);

  if (!user) return null;

  return (
    <div className={style.wrapper}>
      <form>
        <div className={style.section}>
          <h1>Edycja użytkownika:</h1>
          <br />
          <h3 className={style.category}>Dane użytkownika:</h3>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='userName-data'>
              Nazwa użytkownika:
            </label>
            <input
              id='userName-data'
              placeholder='nazwa użytkownika'
              name='userName'
              onChange={handleChange}
              value={formData.userName || location.state.userName || ''}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='surName-data'>
              Imię i nazwisko:
            </label>
            <input placeholder='Imię i nazwisko' name='surName' onChange={handleChange} value={formData.surName || location.state.surName || ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='surName-data'>
              Adres e-mail:
            </label>
            <input placeholder='podaj adres e-mail' name='email' type='email' onChange={handleChange} value={formData.email || location.state.email || ''} />
          </div>
          <hr />
          <h3>Uprawnienia:</h3>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageUsers'>
              Administracja aplikacji, zarządzanie innymi użytkownikami:
            </label>
            <input
              id='manageUsers'
              type='checkbox'
              name='manageUsers'
              onChange={handleChange}
              defaultChecked={formData.manageUsers || location.state.permissions.manageUsers || ''}
            />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageCarriage'>
              Edycja bazy transportów:
            </label>
            <input
              id='manageCarriage'
              type='checkbox'
              name='manageCarriage'
              onChange={handleChange}
              defaultChecked={formData.manageCarriage || location.state.permissions.manageCarriage || ''}
            />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='managePaletts'>
              Edycja bazy palet:
            </label>
            <input
              id='managePaletts'
              type='checkbox'
              name='managePaletts'
              onChange={handleChange}
              defaultChecked={formData.managePaletts || location.state.permissions.managePaletts || ''}
            />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageInvoice'>
              Edycja faktur:
            </label>
            <input
              id='manageInvoice'
              type='checkbox'
              name='manageInvoice'
              onChange={handleChange}
              defaultChecked={formData.manageInvoice || location.state.permissions.manageInvoice || ''}
            />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageCarsService'>
              Edycja bazy serwisu pojazdów:
            </label>
            <input
              id='manageCarsService'
              type='checkbox'
              name='manageCarsService'
              onChange={handleChange}
              defaultChecked={formData.manageCarsService || location.state.permissions.manageCarsService || ''}
            />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageNotes'>
              Edycja notatek:
            </label>
            <input
              id='manageNotes'
              type='checkbox'
              name='manageNotes'
              onChange={handleChange}
              defaultChecked={formData.manageNotes || location.state.permissions.manageNotes || ''}
            />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageNotes'>
              Edycja przydzielonych pojazdów:
            </label>
            <MultipleSelectCheckmarks
              data={cars}
              labelProp='plate'
              customRender={(item) => `${item.plate} (${item.brand || 'brak danych'})`}
              label='Przydzielone pojazdy:'
              value={formData.allowedCars || location.state.allowedCars || []}
              onChange={(value) => setFormData({ name: 'allowedCars', value })}
            />
          </div>
          <br />
          <br />
          <hr />
          <br />
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='password'>
              Nowe hasło dla użytkownika:
            </label>
            <input
              id='password'
              minLength={8}
              placeholder='podaj hasło'
              name='password'
              type='password'
              onChange={handleChange}
              value={formData.password || ''}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='passwordConfirm'>
              Powtórz hasło:
            </label>
            <input name='passwordConfirm' placeholder='potwierdź hasło' type='password' onChange={handleChange} value={formData.passwordConfirm || ''} />
          </div>
        </div>
        <hr />
        <div className={style.buttons}>
          <button id='cancel' className='btn btn-default' onClick={navigate.bind(null, '../userList')}>
            Anuluj
          </button>
          {!location.state.permissions.administrator && (
            <button id='remove' className='btn btn-danger' onClick={handleDeleteAppUser}>
              Usuń użytkownika
            </button>
          )}
          <button id='force-logout' className='btn btn-danger' onClick={handleForceLogout}>
            Wymuś wylogowanie użytkownika
          </button>

          <button id='submit' className='btn btn-default' type='submit' onClick={handleSubmit}>
            Zaktualizuj użytkownika
          </button>
        </div>
      </form>

      {submitting && <ConfirmData />}
    </div>
  );
}

export default EditUserByAdmin;
